import { SidebarItem } from '@backstage/core-components';
import { BasicPermission } from '@backstage/plugin-permission-common';
import { usePermission } from '@backstage/plugin-permission-react';
import { makeStyles, Tooltip } from '@material-ui/core';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';
import { SvgIconTypeMap } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles({
  disabledItem: {
    opacity: 0.5,
    cursor: 'pointer',
  },
});

interface PermissionAwareSidebarItemProps {
  icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
  to: string;
  text: string;
  permission: BasicPermission;
  permissionDeniedUrl?: string;
  permissionDeniedMessage?: string;
}

export const PermissionAwareSidebarItem = ({
  icon,
  to,
  text,
  permission,
  permissionDeniedUrl,
  permissionDeniedMessage = `You don't have permission to access ${text}. Click to learn how to get access.`,
}: PermissionAwareSidebarItemProps) => {
  const classes = useStyles();
  const { allowed } = usePermission({ permission });

  const handleClick = (e: React.MouseEvent) => {
    if (!allowed && permissionDeniedUrl) {
      e.preventDefault();
      window.open(permissionDeniedUrl, '_blank');
    }
  };

  const targetUrl = !allowed && permissionDeniedUrl ? permissionDeniedUrl : to;

  return (
    <Tooltip
      title={!allowed ? permissionDeniedMessage : ''}
      placement="right-start"
    >
      <div
        className={!allowed ? classes.disabledItem : undefined}
        onClick={handleClick}
      >
        <SidebarItem icon={icon} to={targetUrl} text={text} />
      </div>
    </Tooltip>
  );
};
